import { GetServerSideProps } from 'next'
import { useTranslation } from 'next-i18next'
import NextImage from 'next/image'
import { SEO, withPrivateRoute, withPrivateRouteProps } from '@/components'
import { useIsQueryOwner, useIsResponsive } from '@/hooks'
import Footer from '@/components/EMT/Footer'
import Box from '@mui/material/Box'
import { Images, Routes } from '@/assets/configs'
import NextALink from '@/components/NextALink'
import { EmtBreadcrumbs, EmtHeader, EmtIcon, EmtPaper, EmtTypography } from 'emt-components-v2'
import Container from '@mui/material/Container'
import { styled } from '@mui/material/styles'
import VariantImages from '@/assets/VariantImages'
import ContainerTitleNode from '@/components/EMT/ContainerTitleNode'
import getEMTServerSideProps, { EMTServerSideProps } from '@/helpers/getEMTServerSideProps'
import { NavigationPetSitter } from '@/components/PetSitter/NavigationPetSitter'

const StyledEmtPaper = styled(EmtPaper)(() => ({
  flexWrap: 'wrap',
  alignItems: 'flex-start',
}))

type Props = withPrivateRouteProps & EMTServerSideProps

const AssistancePage: React.FC<Props> = ({ url, title }) => {
  const { t } = useTranslation('settings')
  const { t: tc } = useTranslation('common')
  const [isMobile] = useIsResponsive()

  const [, , appendQueryType] = useIsQueryOwner()

  return (
    <>
      <SEO url={`${url}`} subtitle={title} />
      <Box sx={{ overflow: 'hidden' }}>
        <NavigationPetSitter />
      </Box>

      {/* Header Desktop */}
      {!isMobile && (
        <EmtHeader background={Images.Header.Pattern} backgroundColor={'#762D8A'}>
          <EmtBreadcrumbs variant="white">
            <NextALink href={appendQueryType(Routes.Pro.Dashboard)}>
              <EmtIcon className="emt-paw" />
              {tc('breadcrumbs.home')}
            </NextALink>
            <EmtTypography>{title}</EmtTypography>
          </EmtBreadcrumbs>
        </EmtHeader>
      )}
      {/* END Header Desktop */}

      <Container
        sx={{
          paddingTop: '30px',
          paddingBottom: 0,
          display: 'flex',
          flexDirection: 'column',
          rowGap: '24px',
          minHeight: '60vh',
        }}
        maxWidth="sm"
      >
        <ContainerTitleNode title={title} />

        <Box>
          <EmtTypography variant="h5" fontWeight={700}>
            {t('assistance.h24')}
          </EmtTypography>
          <EmtTypography variant="body1">{t('assistance.onlyEmergency')}</EmtTypography>
        </Box>

        <StyledEmtPaper elevation={0} variant="information">
          <Box>
            <NextImage src={VariantImages.PhoneImg} alt="" />
          </Box>
          <Box>
            <EmtTypography variant="body1" fontWeight={700}>
              {t('assistance.info')}
            </EmtTypography>
            <EmtTypography variant="caption" fontWeight={600} color="greyGradient.light">
              {t('assistance.text')}
            </EmtTypography>
          </Box>
        </StyledEmtPaper>
      </Container>

      <Footer topDesktopSrc={VariantImages.FooterTopDesktopPurple} topMobileSrc={VariantImages.FooterTopMobilePurple} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = getEMTServerSideProps({
  namespaces: ['common', 'settings'],
  i18nTitleNs: 'settings',
  i18nTitleKey: 'assistance.title',
})

export default withPrivateRoute()(AssistancePage)
